import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getSelectionConferenceChampsData = (state, setState) => {
  const api = initApi(API_NAMES.MEET, state, setState);

  const url = `/OmeSelectionsMeet/ConferenceChampions`;
  return api?.executeArray ? api.executeArray(url, 'GET') : null;
};

const putSelectionConfirmNCAAConfChampsData = (champsArray, state, setState) => {
  if (champsArray && champsArray.length > 0) {
    const api = initApi(API_NAMES.MEET, state, setState);

    const url = `/OmeSelectionsMeet/ConfirmNCAAConferenceChampions`;
    return api?.executeArray ? api.executeArray(url, 'PUT', champsArray) : null;
  }
};

const putSelectionProcessNCAAConfChampsData = (state, setState) => {
    const api = initApi(API_NAMES.MEET, state, setState);

    const url = `/OmeSelectionsMeet/ProcessNCAAConferenceChampions`;
    return api?.executeArray ? api.executeArray(url, 'PUT') : null;
};

const putSelectionClearNCAAConfChampsConfirmationData = (ncaaConferenceChampionsId, state, setState) => {
  if (ncaaConferenceChampionsId > 0) {
    const api = initApi(API_NAMES.MEET, state, setState);

    const ncaaConferenceChampionsIdForUrl = encodeURIComponent(ncaaConferenceChampionsId);
    const url = `/OmeSelectionsMeet/ClearNCAAConferenceChampionsConfirmation/${ncaaConferenceChampionsIdForUrl}`;
    return api?.executeArray ? api.executeArray(url, 'PUT') : null;
  }
};

const SelectionsConferenceChampsData = {
  getSelectionConferenceChampsData,
  putSelectionConfirmNCAAConfChampsData,
  putSelectionProcessNCAAConfChampsData,
  putSelectionClearNCAAConfChampsConfirmationData
};

export default SelectionsConferenceChampsData;